export function TrustPain() {
  return (
    <section id="about" className="bg-white py-24 md:py-32" data-testid="trust-pain-section">
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
        <p
          className="text-[11px] md:text-[13px] uppercase tracking-[0.45em] text-brand-navy/50 mb-4"
          data-testid="trust-pain-eyebrow"
        >
          Run Better Operations.
        </p>
        <h2
          className="font-poppins font-semibold text-brand-navy text-3xl md:text-5xl tracking-tight leading-tight"
          data-testid="trust-pain-heading"
        >
          Compliance Comes Naturally.
        </h2>
      </div>

      <div className="mt-16 md:mt-20 max-w-5xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-[1fr_auto_1fr] gap-10 md:gap-14 items-start">
          <p
            className="text-brand-slate/85 text-base md:text-[17px] leading-relaxed"
            data-testid="trust-pain-body"
          >
            Your team's energy belongs on customers, products and growth — not on chasing
            SOPs, audit prep and batch records. Yet as companies scale, operational
            compliance quietly steals more and more of that energy.
          </p>

          <div className="hidden md:block h-full w-px bg-brand-navy/15 mx-auto" aria-hidden="true" />

          <p
            className="text-brand-slate/85 text-base md:text-[17px] leading-relaxed"
            data-testid="trust-pain-bridge"
          >
            Vanguard Beacon takes compliance tracking off your plate. We digitise your
            daily operations, standardise SOPs and capture accurate operational data —
            so every outlet runs consistently, every manager has visibility, and every
            audit is always ready.
          </p>
        </div>
      </div>
    </section>
  );
}
